import * as yup from 'yup'
import { TFunction } from 'i18next'
export const dayOffSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        day_off: yup.object().shape({
            day_off_reason: yup
                .string()
                .required('Day off reason is required')
                .min(100, t('min-characters', { count: 100 })),
        }),
    })
